var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjects1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 325,
    viewBox: "0 0 343 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6536 274.912C66.3755 270.738 20.7502 245.278 7.84569 238.766C6.97603 238.326 6.27167 237.617 5.83719 236.745C5.40271 235.872 5.26129 234.883 5.43392 233.925C5.87242 231.535 6.9478 228.488 9.5475 226.693C10.2088 226.24 10.9787 225.97 11.7784 225.912C12.5781 225.853 13.3791 226.007 14.0996 226.359L85.9725 261.514C86.257 261.652 86.5123 261.843 86.7242 262.078L96.413 272.512C96.6461 272.777 96.7972 273.103 96.8479 273.452C96.8985 273.801 96.8465 274.157 96.6981 274.476C96.5498 274.796 96.3116 275.066 96.0125 275.253C95.7135 275.439 95.3665 275.535 95.014 275.528L80.3972 275.173C79.8066 275.169 79.2196 275.081 78.6536 274.912Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3565 270.739C93.2394 271.355 92.2684 273.598 92.0596 275.101",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9491 261.505C81.3053 265.491 79.1128 270.155 79.5409 274.434",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6214 227.508C11.5624 229.72 8.98354 234.395 8.21094 238.089",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.979 290.168H27.2969V324.999H74.979V290.168Z",
    fill: "#3098F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7041 319.48C37.5903 314.597 45.6817 304.026 50.4531 306.959C53.3764 308.722 58.1373 314.743 60.7684 316.903",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2373 310.245C56.8637 308.972 61.1235 305.82 67.0955 307.354",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6431 294.916H32.3076V320.293H69.6431V294.916Z",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M331.065 45.6009L271.407 45.5176C270.623 45.5165 269.986 46.151 269.985 46.9348L269.936 82.0895C269.935 82.8733 270.57 83.5095 271.354 83.5106L331.012 83.5939C331.796 83.595 332.432 82.9605 332.433 82.1767L332.483 47.022C332.484 46.2382 331.849 45.602 331.065 45.6009Z",
    fill: "#3098F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.606 46.8613C281.002 53.1222 299.795 64.2352 300.923 64.7674C302.051 65.2996 304.65 66.51 305.621 66.3639C307.233 66.151 308.767 65.5454 310.09 64.6005C316.135 60.4265 328.173 50.7952 331.034 47.9048",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.706 39.7649L48.8248 39.0867C51.4719 39.0299 54.1044 39.4951 56.5716 40.4557C59.0388 41.4163 61.2923 42.8535 63.2035 44.6851C65.1146 46.5167 66.6458 48.7067 67.7096 51.1301C68.7734 53.5535 69.3488 56.1626 69.4031 58.8084V58.8084C69.507 63.6716 67.8461 68.4081 64.7275 72.1426C61.6089 75.8771 57.2432 78.3573 52.4372 79.1249C52.3533 79.134 52.2737 79.1666 52.2075 79.2188L39.1464 88.7354C39.0678 88.7925 38.9751 88.8271 38.8783 88.8354C38.7815 88.8436 38.6843 88.8253 38.5972 88.7823C38.5101 88.7393 38.4364 88.6733 38.3842 88.5915C38.3319 88.5096 38.303 88.415 38.3007 88.318L38.1232 80.158C38.1177 80.0159 38.0567 79.8816 37.9532 79.784C37.8497 79.6865 37.7121 79.6334 37.5698 79.6362L20.583 80.0119C15.242 80.1266 10.074 78.1169 6.21517 74.4245C2.35632 70.7322 0.122446 65.6594 0.00465528 60.3214V60.3214C-0.11011 54.9844 1.90105 49.8204 5.59574 45.9653C9.29043 42.1103 14.366 39.8799 19.706 39.7649V39.7649Z",
    fill: "#F2EAE2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2075 52.1094C27.6305 52.4429 44.5129 52.839 59.7875 52.1823",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7505 61.2197C11.7505 61.2197 25.9288 61.7617 32.7882 61.5533",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 61.1774C39.543 61.1774 53.1784 60.896 59.3174 60.6875",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.041 51.1912L106.025 40.3359L95.6091 67.1887L123.625 78.0439L134.041 51.1912Z",
    fill: "#3098F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.892 49.0518C115.871 51.1387 121.742 53.5352 127.505 56.2413",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.974 54.2061C111.834 55.4895 115.165 56.6895 118.036 57.973",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.619 69.9114C114.807 69.9114 115.77 68.949 115.77 67.7619C115.77 66.5747 114.807 65.6123 113.619 65.6123C112.431 65.6123 111.468 66.5747 111.468 67.7619C111.468 68.949 112.431 69.9114 113.619 69.9114Z",
    fill: "#FE6571"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.279 67.4905C125.467 67.4905 126.43 66.5281 126.43 65.341C126.43 64.1538 125.467 63.1914 124.279 63.1914C123.091 63.1914 122.128 64.1538 122.128 65.341C122.128 66.5281 123.091 67.4905 124.279 67.4905Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.165 74.0228C121.353 74.0228 122.316 73.0604 122.316 71.8732C122.316 70.686 121.353 69.7236 120.165 69.7236C118.978 69.7236 118.015 70.686 118.015 71.8732C118.015 73.0604 118.978 74.0228 120.165 74.0228Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.829 128.148L96.666 138.616L106.71 165.61L134.874 155.142L124.829 128.148Z",
    fill: "#F2EAE2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.744 142.694C110.622 140.315 116.96 137.56 123.036 135.734",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.085 147.035C111.082 146.096 114.35 144.781 117.367 143.842",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.035 152.232C128.223 152.232 129.186 151.269 129.186 150.082C129.186 148.895 128.223 147.933 127.035 147.933C125.847 147.933 124.884 148.895 124.884 150.082C124.884 151.269 125.847 152.232 127.035 152.232Z",
    fill: "#3098F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.708 193.991L131.065 202.798L107.866 209.351L100.025 181.637L128.945 173.477L134.708 193.991Z",
    fill: "#3098F3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.05 184.86C110.904 183.222 118.505 181.427 123.287 179.82C123.37 179.82 124.435 183.608 124.801 184.693C124.801 184.693 112.178 188.043 106.363 189.786C106.06 189.232 105.465 187.02 104.943 185.612",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.25 193.96C132.099 194.659 130.074 195.003 127.892 195.65C128.8 197.581 129.865 200.346 130.888 202.297",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.95 192.718C111.604 191.601 117.545 189.963 121.22 188.898",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.129 195.609C111.482 194.778 113.881 194.082 116.313 193.522",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6937 181.271H20.2283C18.7968 181.271 17.4238 180.702 16.4115 179.691C15.3993 178.679 14.8306 177.307 14.8306 175.876V142.881C14.8954 141.422 15.5232 140.045 16.5823 139.04C17.6413 138.034 19.0492 137.477 20.5102 137.486H59.9756C60.6701 137.491 61.3564 137.636 61.9935 137.913C62.6305 138.189 63.2051 138.591 63.6829 139.095C64.1606 139.599 64.5316 140.194 64.7737 140.845C65.0157 141.495 65.1238 142.188 65.0915 142.881V175.876C65.0887 177.306 64.5191 178.677 63.5075 179.688C62.4958 180.699 61.1244 181.268 59.6937 181.271Z",
    fill: "#F2EAE2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9606 176.993C49.6939 176.993 57.5843 169.107 57.5843 159.38C57.5843 149.652 49.6939 141.766 39.9606 141.766C30.2273 141.766 22.3369 149.652 22.3369 159.38C22.3369 169.107 30.2273 176.993 39.9606 176.993Z",
    fill: "#FE6571"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M323.318 146.899H282.997V176.357H323.318V146.899Z",
    fill: "#FFCC00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M318.797 150.906H287.235V172.36H318.797V150.906Z",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M291.902 144.604C291.902 145.824 291.902 147.045 291.902 148.266",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M303.094 144.479C303.188 145.699 303.094 146.931 303.042 148.152",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M315.153 144.656C315.247 145.743 315.247 146.836 315.153 147.922",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M186.265 176.701H219.873V198.353C219.874 200.351 219.481 202.329 218.715 204.175C217.95 206.02 216.827 207.696 215.412 209.107C213.996 210.518 212.316 211.635 210.468 212.395C208.619 213.155 206.639 213.543 204.64 213.536H201.393C197.367 213.536 193.506 211.937 190.659 209.092C187.812 206.247 186.212 202.388 186.212 198.364V176.701H186.265Z",
    fill: "#FE6571"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.818 181.126C192.487 169.647 187.256 142.736 189.877 139.324C191.652 137.018 193.406 140.253 194.638 144.729C196.363 152.026 197.325 159.481 197.509 166.976C197.582 157.355 197.217 152.013 198.052 142.423C198.939 132.364 200.244 124.517 203.366 125.957C207.668 127.95 204.013 155.915 203.846 165.025C205.392 153.442 210.8 127.136 216.291 129.275C220.405 130.882 215.623 155.884 211.176 167.237C212.877 164.357 216.584 156.907 219.058 157.554C225.124 159.161 213.347 176.587 208.221 180.207",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M202.061 42.8327C208.249 42.8327 214.185 45.2898 218.561 49.6635C222.937 54.0372 225.395 59.9691 225.395 66.1544V77.424H178.726V66.144C178.726 59.9587 181.185 54.0267 185.561 49.653C189.937 45.2794 195.872 42.8223 202.061 42.8223V42.8327Z",
    fill: "#FFCC00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M202.04 1C201.831 14.3252 201.696 33.5565 201.696 46.433",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M193.343 76.7771C193.902 78.5415 195.015 80.0789 196.517 81.1615C198.018 82.2441 199.829 82.8141 201.681 82.7872C203.532 82.7603 205.326 82.1377 206.795 81.0119C208.265 79.8861 209.332 78.317 209.839 76.5371",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M216.009 271.303H170.666C167.24 271.303 164.464 274.078 164.464 277.501V315.411C164.464 318.834 167.24 321.609 170.666 321.609H216.009C219.434 321.609 222.211 318.834 222.211 315.411V277.501C222.211 274.078 219.434 271.303 216.009 271.303Z",
    fill: "#F2EAE2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M207.511 296.899H179.854C175.328 296.899 171.658 300.567 171.658 305.091C171.658 309.615 175.328 313.282 179.854 313.282H207.511C212.038 313.282 215.707 309.615 215.707 305.091C215.707 300.567 212.038 296.899 207.511 296.899Z",
    fill: "#FE6571"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.215 282.812C187.611 283.03 197.415 283.135 206.937 282.916",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M178.716 289.521C182.057 289.584 187.83 289.438 192.497 289.605",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M307.594 283.073L268.139 274.11C267.691 274.001 267.22 274.034 266.792 274.206C266.363 274.378 266 274.679 265.751 275.068C265.503 275.456 265.382 275.913 265.406 276.373C265.43 276.834 265.597 277.276 265.884 277.637L291.004 309.442C291.11 309.602 291.257 309.731 291.431 309.813C291.605 309.895 291.798 309.928 291.989 309.907C292.18 309.887 292.362 309.814 292.514 309.697C292.666 309.58 292.783 309.423 292.852 309.243L298.469 297.87C298.58 297.649 298.613 297.397 298.564 297.155C298.515 296.913 298.386 296.694 298.198 296.534L296.767 295.428L300.286 289.303L302.499 289.96C302.656 290.013 302.824 290.02 302.985 289.981C303.146 289.943 303.292 289.859 303.408 289.741L308.033 284.523C308.138 284.411 308.211 284.274 308.246 284.124C308.28 283.975 308.275 283.819 308.231 283.672C308.187 283.525 308.104 283.393 307.993 283.288C307.881 283.183 307.744 283.109 307.594 283.073V283.073Z",
    fill: "#3098F3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M296.235 295.261L267.544 275.998",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M299.639 288.718L267.513 276.05",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M301.936 292.736C308.44 295.272 314.464 299.362 314.12 306.302C313.994 308.691 311.092 310.882 308.983 307.658C306.509 303.881 309.14 296.722 317.638 299.258C325.531 301.606 331.879 307.606 336.577 314.357",
    stroke: "#092C4E",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M273.641 215.644C276.564 204.813 293.677 205.762 296.788 207.161C298.427 204.03 303.48 199.324 311.321 198.375C329.425 196.194 333.852 208.277 333.852 208.277C333.852 208.277 342.371 208.716 342.966 215.769C343.022 216.109 343.008 216.457 342.925 216.791C342.841 217.125 342.69 217.439 342.481 217.713C342.272 217.986 342.008 218.214 341.708 218.383C341.407 218.551 341.075 218.656 340.732 218.691C329.843 218.587 287.966 218.816 276.199 218.691C275.564 218.706 274.945 218.491 274.457 218.084C273.969 217.677 273.646 217.106 273.547 216.479C273.522 216.197 273.553 215.913 273.641 215.644Z",
    fill: "#F2EAE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects1);
export default __webpack_public_path__ + "static/media/objects1.195417f087412cf3df6c575b0d76f67b.svg";
export { ForwardRef as ReactComponent };